import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './BlogPost.css';

function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [relatedPosts, setRelatedPosts] = useState([]);

  useEffect(() => {
    fetchPost();
    window.scrollTo(0, 0);
  }, [slug]);

  const fetchPost = async () => {
    try {
      const response = await axios.get(`https://api.chekidesara.ir/api/blog/post/${slug}`);
      const postData = response.data.data;
      setPost(postData);
      
      // دریافت مقالات مرتبط
      const relatedResponse = await axios.get(`https://api.chekidesara.ir/api/blog/related/${postData._id}`);
      setRelatedPosts(relatedResponse.data.data);
    } catch (error) {
      console.error('Error fetching post:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">در حال بارگذاری مقاله...</div>;
  if (!post) return <div className="not-found">مقاله یافت نشد</div>;

  return (
    <div className="blog-post-page">
      <div className="container">
        <article className="blog-post">
          <h1>{post.title}</h1>
          <div className="post-meta">
            <span>📅 {new Date(post.publishedAt).toLocaleDateString('fa-IR')}</span>
            {/* <span>✍️ {post.author}</span> */}
            <span>⏱️ {post.readTime} دقیقه مطالعه</span>
            <span>👁️ {post.views} بازدید</span>
          </div>
          
          {post.image && <img src={post.image} alt={post.title} className="post-image" />}
          
          <div className="post-content" dangerouslySetInnerHTML={{ __html: post.content }} />
          
          {post.tags && post.tags.length > 0 && (
            <div className="post-tags">
              {post.tags.map(tag => (
                <span key={tag} className="tag">#{tag}</span>
              ))}
            </div>
          )}
        </article>
        
        {relatedPosts.length > 0 && (
          <div className="related-posts">
            <h3>📚 مقالات مرتبط</h3>
            <div className="related-grid">
              {relatedPosts.map(related => (
                <Link key={related._id} to={`/blog/${related.slug}`} className="related-card">
                  <h4>{related.title}</h4>
                  <p>{related.excerpt}</p>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default BlogPost;